import { css, styled, TableContainer as MuiTableContainer } from '@mui/material';

import { tableContainerClasses } from './theme';

import type { TableContainerOwnerState, TableContainerProps } from './types';

const TableContainer = (props: TableContainerProps) => {
  const { variant = 'auto', ...others } = props;

  const ownerState: TableContainerOwnerState = {
    ...props,
    variant,
  };

  return <TableContainerRoot {...others} variant={variant} ownerState={ownerState} />;
};

export default TableContainer;

const TableContainerRoot = styled(MuiTableContainer, {
  target: tableContainerClasses.root,
  shouldForwardProp: prop => !['variant'].includes(prop as string),
})<TableContainerProps & { ownerState: TableContainerOwnerState }>(
  ({ ownerState, theme }) => css`
    background-color: white;
    width: ${ownerState.variant === 'auto' ? '100%' : 'fit-content'};
    border-top: 1px solid ${theme.color['border/weaker/default']};
    border-bottom: 1px solid ${theme.color['border/weaker/default']};
    border-spacing: 0;
  `,
);
